import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useNavigate } from 'react-router-dom';
import '../styles/pages/_sleeping-meditation.scss';

const sleepingImage = require('../assets/sleeping.png');

const sessions = [
  {
    id: 1,
    title: 'Session 1: Sleep Meditation',
    path: '/panel/dashboard/sleeping-meditation/session-1',
  },
  {
    id: 2,
    title: 'Session 2: Sleep Meditation',
    path: '/panel/dashboard/sleeping-meditation/session-2',
  },
  {
    id: 3,
    title: 'Session 3: Sleep Meditation',
    path: '/panel/dashboard/sleeping-meditation/session-3',
  },
];

const SleepingMeditationPage: React.FC = () => {
  const { isDarkMode } = useTheme();
  const navigate = useNavigate();
  return (
    <div className={`resources-page${isDarkMode ? ' dark' : ''}`}> 
      <div className="module-resources_container">
        <div className="module-resources_header">
          <div className="module-resources_header-content">
            <div className="module-resources_header-text">
              <h2>Sleeping Meditation</h2>
            </div>
          </div>
        </div>
        <div className="module-resources_modules">
          <div className="module-resources_modules-grid">
            {sessions.map((s) => (
              <div 
                key={s.id} 
                className="module-resources_module-card"
                onClick={() => navigate(s.path)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') navigate(s.path);
                }}
              >
                <div className="module-resources_module-image">
                  <img src={sleepingImage.default || sleepingImage} alt={s.title} />
                </div>
                <div className="module-resources_module-content">
                  <h3 className="module-resources_module-title">{s.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bedtime Stories Section */}
        <div className="module-resources_header" style={{marginTop: '48px'}}>
          <div className="module-resources_header-content">
            <div className="module-resources_header-text">
              <h2>Bedtime Stories</h2>
            </div>
          </div>
        </div>
        <div className="module-resources_modules">
          <div className="module-resources_modules-grid">
            <div 
              className="module-resources_module-card"
              onClick={() => navigate('/panel/dashboard/sleeping-meditation/bedtime-story-1')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') navigate('/panel/dashboard/sleeping-meditation/bedtime-story-1');
              }}
            >
              <div className="module-resources_module-image">
                <img src={sleepingImage.default || sleepingImage} alt="Bedtime Story 1" />
              </div>
              <div className="module-resources_module-content">
                <h3 className="module-resources_module-title">The Little Bat Who Wouldn't Go To Bed</h3>
              </div>
            </div>
            <div 
              className="module-resources_module-card"
              onClick={() => navigate('/panel/dashboard/sleeping-meditation/bedtime-story-2')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') navigate('/panel/dashboard/sleeping-meditation/bedtime-story-2');
              }}
            >
              <div className="module-resources_module-image">
                <img src={sleepingImage.default || sleepingImage} alt="Bedtime Story 2" />
              </div>
              <div className="module-resources_module-content">
                <h3 className="module-resources_module-title">The Sleepy Treehouse</h3>
              </div>
            </div>
            <div 
              className="module-resources_module-card"
              onClick={() => navigate('/panel/dashboard/sleeping-meditation/bedtime-story-3')}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') navigate('/panel/dashboard/sleeping-meditation/bedtime-story-3');
              }}
            >
              <div className="module-resources_module-image">
                <img src={sleepingImage.default || sleepingImage} alt="Bedtime Story 3" />
              </div>
              <div className="module-resources_module-content">
                <h3 className="module-resources_module-title">Cozy Autumn Bedtime Stories</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SleepingMeditationPage;

